"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIQuoteSearchFilterEntity = void 0;
function parseIQuoteSearchFilterEntity(data) {
    if (typeof data.from_created_date === 'string')
        data.from_created_date = new Date(data.from_created_date);
    if (typeof data.to_created_date === 'string')
        data.to_created_date = new Date(data.to_created_date);
    return data;
}
exports.parseIQuoteSearchFilterEntity = parseIQuoteSearchFilterEntity;
